import { ApiSchema } from "@api-types";
import { useObservable } from "@rsm";
import { getFFService } from "services/ff.service";

export const useHasFF = (ff: ApiSchema.FF) => {
  return useObservable(getFFService().featureEnabled$(ff));
};
